import React, {useEffect, useRef, useState} from "react";
import {useMapsLibrary} from "@vis.gl/react-google-maps";

interface PlaceAutocompleteProps {
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
  defaultValue: string,
  className: string,
}

export const PlaceAutocomplete = (props: PlaceAutocompleteProps) => {
  const [placeAutocomplete, setPlaceAutocomplete] =
      useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) {
      return;
    }

    const options = {
      fields: ['geometry', 'name', 'formatted_address']
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));

  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) {
      return;
    }

    placeAutocomplete.addListener('place_changed', () => {
      console.log(JSON.stringify(placeAutocomplete.getPlace()));
      props.onPlaceSelect(placeAutocomplete.getPlace());
    });

  }, [props.onPlaceSelect, placeAutocomplete]);

  return <input className={props.className} defaultValue={props.defaultValue} ref={inputRef}/>;
};
